import { Typography } from 'antd'
import React from 'react'

function Monetization() {
  return (
    <div>
        <Typography.Title level={3}>Monetization</Typography.Title>
    </div>
  )
}

export default Monetization